import authorizationService from "./authorization.service.js";


export async function handleResponse(response) {



    return response.text()
        .then(text => {

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    authorizationService.logOut();
                    window.location = "/#/signin";
                    //window.location.reload();
                }
                const error = text || response.statusText;
                return Promise.reject(error);
            }
            const data = text && JSON.parse(text);
            return data;
        });
}

export function authHeader() {
    // return authorization header with basic auth credentials
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));

    if (accessToken) {
        return {
            'Authorization': 'Bearer ' + accessToken,
            "Content-Type": "application/json"
        };
    } else {
        return {};
    }
}

export function authHeaderWithFile() {
    // return authorization header with basic auth credentials
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));

    if (accessToken) {
        return {
            'Authorization': 'Bearer ' + accessToken
        };
    } else {
        return {};
    }
}